import {keyBy, partition, isEqual, size, createReducer, map, omit, keys} from 'helpers';
import {isGoogleEventId} from 'store/google-calendar';

export const events = createReducer({}, {

  GOOGLE_CALENDAR_DATA_RECEIVED: (state, { events, select }) => {
    const stored = keys(select('activities.storedGoogleEvents'));
    const [ confirmed, cancelled ] = partition(events, event => event.status == 'Not Started');
    const updated = omit({
      ...state,
      ...keyBy(confirmed, 'id'),
    }, [ ...stored, ...map(cancelled, 'id') ]);
    return isEqual(state, updated) ? state : updated;
  },

  SERVER_DATA_RECEIVED_AFTER: (state, action) => {
    const stored = keys(action.select('activities.storedGoogleEvents'));
    const updated = omit(state, stored);
    return size(state) == size(updated) ? state : updated;
  },

  ACTIVITIES_STORE_GOOGLE_EVENT: (state, action) => {
    return omit(state, action.googleEventId);
  },

  ACTIVITIES_DELETE: (state, action) => {
    if (isGoogleEventId(action.id)) {
      return omit(state, action.id);
    }
    return state;
  },

  GOOGLE_CALENDAR_SIGNED_OUT: () => ({}),

});
